module.exports = "/assets/88ac5142068c5efce5650b2d946c5e00.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AO.png
// module id = 1202
// module chunks = 0